import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import Qualities from './Qualities'


const Home = () =>  {



    const [letterClass, setLetterClass] = useState('text-animate')
    const nameArray = [
        ' ',
        'E', 
        's', 
        'h', 
        'a', 
        'n', 
        ' ', 
        'P',
        'r',
        'a',
        'k',
        'a',
        's',
        'h',
        ','
    ]
    const jobArray = [
        'A',
        ' ',
        'c',
        'o',
        'm',
        'p',
        'u',
        't',
        'e',
        'r',
        ' ',
        's',
        'c',
        'i',
        'e',
        'n',
        't',
        'i',
        's',
        't',
        '.'
    ]

    useEffect(() => {
        let timeout = setTimeout(() => {
            setLetterClass("text-animate-hover");
        }, 4000);
       
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return (
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>i.</span>
                <br/>
                <span className={`${letterClass} _12`}>I</span>
                <span className={`${letterClass} _12`}>'m</span>
                <AnimatedLetters letterClass={letterClass}
                strArray={nameArray}
                idx={15}/>
                <br/>
                <AnimatedLetters letterClass={letterClass}
                strArray={jobArray}
                idx={15}/>
                </h1>
                <h2>Full-Stack Development / Machine Learning / Data Science</h2>
                <Link to='/about' className='flat-button'>ABOUT ME</Link>
                <Link to='/contact' className='flat-button last-button'>CONTACT ME</Link>
            </div>
            <Qualities/>
        </div>
    )
}

export default Home